import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { ArrowRight } from "lucide-react";

export default function LaunchConfirmedPage() {
  return (
    <div className="min-h-screen bg-black flex flex-col">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-sm border-b border-white/[0.06]/30">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-center h-16">
            <Link to="/earlyaccess">
              <span className="font-heading text-xl font-bold text-white tracking-widest">DEALFORGE</span>
            </Link>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-4">
        <div className="max-w-lg text-center">
          <div className="w-16 h-16 border border-white/[0.08] flex items-center justify-center mx-auto mb-10">
            <div className="w-3 h-3 bg-white" />
          </div>
          
          <h1 className="font-heading text-3xl md:text-4xl font-bold text-white mb-6 tracking-tight">
            You're On The Launch List.
          </h1>
          
          <p className="text-white/50 text-lg leading-relaxed mb-10">
            We'll notify you when public access opens. Launch invitations are released in controlled waves.
          </p>

          <div className="border-t border-white/[0.06]/50 pt-10">
            <p className="text-white/40 text-sm mb-5">
              Actively managing deal flow?
            </p>
            <Link to="/earlyaccess#founder">
              <Button 
                className="h-11 px-8 rounded-none bg-red-900/80 hover:bg-red-900 text-white font-medium tracking-wide transition-all duration-200"
                data-testid="apply-founder-btn"
              >
                Apply for Founder Beta
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </Link>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-8 border-t border-white/[0.06]/30">
        <div className="text-center">
          <p className="text-white/30 text-sm tracking-wide">
            DealForge — Transaction Infrastructure
          </p>
        </div>
      </footer>
    </div>
  );
}
